import React, { useMemo } from "react";
import styled, { withTheme } from "styled-components";
import { Button } from "../../ui-library/AuthControls/Button";
import EmailSentIcon from "../../../assets/svg/email_sent.svg";
import { useTranslation } from "react-i18next";

export const StyledIconWrapper = styled.div`
  text-align: center;
`;

export const ModalMessage = styled.p`
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 10px;
  word-wrap: break-word;
`;

const Alert = (props) => {
  const { t } = useTranslation();
  const { icon, title, email, callback, message, btnText } = props;

  const modalMessage = useMemo(
    () => message || t("appText.passwordRecovery.feedback", { email: email }),
    [email, message, t]
  );

  return (
    <form onSubmit={callback} className="auth-form" data-testid="alert">
      <StyledIconWrapper className="icon-wrapper">
        <img src={icon || EmailSentIcon} alt={title ? title : "Success"} />
      </StyledIconWrapper>
      <ModalMessage data-testid="alert-message">{modalMessage}</ModalMessage>
      <Button text={btnText || t("appText.home")} />
    </form>
  );
};
export default withTheme(Alert);
